import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SalesPage = lazy(() => import('../pages/sales/page'));
const PurchasePage = lazy(() => import('../pages/purchase/page'));
const RentalPage = lazy(() => import('../pages/rental/page'));
const MaintenancePage = lazy(() => import('../pages/maintenance/page'));
const BodyworkPaintingPage = lazy(() => import('../pages/bodywork-painting/page'));
const CoatingPage = lazy(() => import('../pages/coating/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sales',
    element: <SalesPage />,
  },
  {
    path: '/purchase',
    element: <PurchasePage />,
  },
  {
    path: '/rental',
    element: <RentalPage />,
  },
  {
    path: '/maintenance',
    element: <MaintenancePage />,
  },
  {
    path: '/bodywork-painting',
    element: <BodyworkPaintingPage />,
  },
  {
    path: '/coating',
    element: <CoatingPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
